import { withConfirmationDialog } from "@components/dialog/withConfirmationDialog";
import { IPrParentalLeaveEventEntity } from "@odata/GeneratedEntityTypes";
import { PrSocialEventTypeCode } from "@odata/GeneratedEnums";
import { SocialEventsFormViewForExtend } from "@pages/payroll/socialEvents/SocialEventsFormView";

import { withPermissionContext } from "../../../../contexts/permissionContext/withPermissionContext";

class ParentalLeaveFormView extends SocialEventsFormViewForExtend<IPrParentalLeaveEventEntity> {
    typeCode = PrSocialEventTypeCode.ParentalLeave;
}

export default withPermissionContext(withConfirmationDialog(ParentalLeaveFormView));